import { BrowserRouter as Router, Route, Routes, NavLink, useNavigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

const homeUrl = process.env.REACT_APP_HOME_URL;
const apiUrl = process.env.REACT_APP_API_URL;

const RiskDisclosure = () => {

  return (
    <div className="termsservice_wrapper riskdisclosure_wrapper">
		<div className="otherpage_banner" style={{ backgroundImage: `url(${homeUrl}/assets/img/risk-disclosure-bgimg.jpg)`,}}>
			<div className="container">
				<div className="row">
					<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
						<div className="toptitlebox">
							<div className="breadcrumb_mainsec">
								<ul>
									<li><a href="#">Home</a></li>
									<li><span>Risk Disclosure</span></li>
								</ul>
							</div>
							
							<div className="titlesec">
								<h2>Risk Disclosure for CoinViews</h2>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div className="termsservice_mainsec riskdisclosure_mainsec">
			<div className="container">
				<div className="row">
					<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
						<div className="contntbox">
							<h2>Purpose</h2>
							
							<p>This Risk Disclosure explains the potential hazards of relying on cryptocurrency information and making decisions based on such content. CoinViews provides price data and educational articles; it is not a brokerage, exchange, or financial advisor. Investing or trading in digital assets involves substantial risk of loss.</p>
							
							<h2>Nature of Digital Assets</h2>
							
							<p><strong>Market Volatility:</strong> Cryptocurrency prices can swing dramatically in a matter of minutes. Shifts in technology, regulatory developments, market sentiment, and overall economic conditions can produce large gains or losses. You may lose some or all of your capital.</p>
							
							<p><strong>Regulatory Risk:</strong> Laws governing digital assets are still evolving. New regulations or government policies could affect your ability to buy, sell, or hold certain tokens. Tax rules and securities regulations may also change, creating new compliance obligations.</p>
							
							<p><strong>Technology Risk:</strong> Crypto transactions depend on blockchain technology. Software bugs, hacking, network outages, or loss of private keys can cause irreversible losses.</p>
							
							<p><strong>Liquidity Risk:</strong> Some cryptocurrencies trade on thin markets. Limited liquidity can make it hard to enter or exit positions without significant price impact.</p>
							
							<p><strong>Third‑Party & Custodial Risk:</strong> Many investors use exchanges or wallet providers. Failures, security breaches, or insolvency at these service providers can negatively affect your holdings..</p>
							
							<p><strong>Fraud & Operational Risk:</strong> The crypto space is prone to scams, misinformation, and operational errors. Transactions are often irreversible, which heightens the risk of permanent loss.</p>
							
							<p><strong>Taxation Risk:</strong> Tax treatment for digital asset transactions varies widely by country and can change with little notice. You are responsible for understanding and following applicable tax regulations.</p>
							
							<p><strong>Environmental & Protocol Risks:</strong> Some coins (e.g., those using proof‑of‑work) consume large amounts of energy, and changes to blockchain protocols can alter the functionality or value of your assets.</p>
							
							<h2>Important Notice</h2>
							
							<p>CoinViews publishes information for general awareness and does not provide personalized investment advice or guarantee any returns. The risks described above are not exhaustive; new risks may emerge as the digital asset industry evolves. By using CoinViews, you accept that we are not responsible for losses incurred through your use of our content. We do not control or maintain the underlying software that powers cryptocurrency networks. Legislative or regulatory changes may force us to modify or discontinue services without notice.</p>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
  );
};

export default RiskDisclosure;